import { platformApi as platform } from './http'

export const fetchAgentDownloads = () => platform.get('/downloads/agent').then((r) => r.data)

export const fetchMe = () => platform.get('/identity/me').then((r) => r.data)
export const sendEmailCode = (payload) => platform.post('/identity/email-code', payload).then((r) => r.data)
export const sendResetCode = (payload) => platform.post('/identity/reset-code', payload).then((r) => r.data)
export const registerUser = (payload) => platform.post('/identity/register', payload).then((r) => r.data)
export const loginUser = (payload) => platform.post('/identity/login', payload).then((r) => r.data)
export const resetPassword = (payload) => platform.post('/identity/reset-password', payload).then((r) => r.data)
export const bindWechat = (payload) => platform.post('/identity/bind-wechat', payload).then((r) => r.data)
export const fetchFollowBonus = () => platform.get('/identity/follow-bonus').then((r) => r.data)
export const fetchMaasConsole = () => platform.get('/identity/maas/console').then((r) => r.data)
export const openMaasConsole = () => platform.post('/identity/maas/sso-ticket', {}).then((r) => r.data)

export const billingMe = () => platform.get('/billing/me').then((r) => r.data)
export const fetchCreditRules = () => platform.get('/billing/rules').then((r) => r.data)
export const billingLedger = () => platform.get('/billing/ledger').then((r) => r.data)
export const adminListUsers = (params) => platform.get('/identity/admin/users', { params }).then((r) => r.data)
export const adminUserBilling = (id, params) =>
  platform.get(`/billing/admin/users/${id}`, { params }).then((r) => r.data)
export const adminGrantCredits = (payload) => platform.post('/billing/admin/grant', payload).then((r) => r.data)

export const catalogSearch = (params) => platform.get('/catalog/search', { params }).then((r) => r.data)
export const catalogPrices = (params) => platform.get('/catalog/prices', { params }).then((r) => r.data)
export const rebuildMetrics = () => platform.post('/catalog/metrics/rebuild', {}).then((r) => r.data)
export const reclassifyVendors = (payload = {}) =>
  platform.post('/catalog/vendors/reclassify', payload).then((r) => r.data)
export const getCardMetrics = (id) => platform.get(`/catalog/metrics/${id}`).then((r) => r.data)
export const putCardMetrics = (id, payload) => platform.put(`/catalog/metrics/${id}`, payload).then((r) => r.data)
export const adminMetricsGaps = () => platform.get('/catalog/admin/metrics/gaps').then((r) => r.data)

export const listSearchAds = (params) => platform.get('/catalog/ads', { params }).then((r) => r.data)
export const adminListSearchAds = () => platform.get('/catalog/admin/ads').then((r) => r.data)
export const adminCreateSearchAd = (payload) =>
  platform.post('/catalog/admin/ads', payload).then((r) => r.data)
export const adminUpdateSearchAd = (id, payload) =>
  platform.put(`/catalog/admin/ads/${id}`, payload).then((r) => r.data)
export const adminDeleteSearchAd = (id) =>
  platform.delete(`/catalog/admin/ads/${id}`).then((r) => r.data)

export const listBomComponents = () => platform.get('/catalog/bom/components').then((r) => r.data)
export const listBomTemplates = () => platform.get('/catalog/bom/templates').then((r) => r.data)
export const bomEstimate = (component_ids) =>
  platform.post('/catalog/bom/estimate', { component_ids }).then((r) => r.data)
export const adminListBomComponents = () => platform.get('/catalog/admin/bom/components').then((r) => r.data)
export const adminCreateBomComponent = (payload) =>
  platform.post('/catalog/admin/bom/components', payload).then((r) => r.data)
export const adminUpdateBomComponent = (id, payload) =>
  platform.put(`/catalog/admin/bom/components/${id}`, payload).then((r) => r.data)
export const adminDeleteBomComponent = (id) =>
  platform.delete(`/catalog/admin/bom/components/${id}`).then((r) => r.data)
export const adminListBomTemplates = () => platform.get('/catalog/admin/bom/templates').then((r) => r.data)
export const adminCreateBomTemplate = (payload) =>
  platform.post('/catalog/admin/bom/templates', payload).then((r) => r.data)
export const adminUpdateBomTemplate = (id, payload) =>
  platform.put(`/catalog/admin/bom/templates/${id}`, payload).then((r) => r.data)
export const adminDeleteBomTemplate = (id) =>
  platform.delete(`/catalog/admin/bom/templates/${id}`).then((r) => r.data)

export const fetchBidAccepts = () => platform.get('/bid/accepts').then((r) => r.data)
export const createBidJob = (payload) => {
  if (payload instanceof FormData) {
    return platform.post('/bid/jobs', payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((r) => r.data)
  }
  return platform.post('/bid/jobs', payload).then((r) => r.data)
}
export const listBidJobs = () => platform.get('/bid/jobs').then((r) => r.data)
export const createAdviseJob = (text) => platform.post('/agent/jobs', { text }).then((r) => r.data)
export const listAdviseJobs = () => platform.get('/agent/jobs').then((r) => r.data)
export const getAdviseJob = (id) => platform.get(`/agent/jobs/${id}`).then((r) => r.data)
export const quoteServer = (text) => platform.post('/agent/quotes', { text }).then((r) => r.data)
export const createQuoteInquiry = (payload) => platform.post('/agent/inquiries', payload).then((r) => r.data)
export const adminListInquiries = () => platform.get('/agent/admin/inquiries').then((r) => r.data)
export const adminInquiryStatus = (id, status) =>
  platform.post(`/agent/admin/inquiries/${id}`, { status }).then((r) => r.data)
export const getBidJob = (id) => platform.get(`/bid/jobs/${id}`).then((r) => r.data)
export const retryBidJob = (id) => platform.post(`/bid/jobs/${id}/retry`).then((r) => r.data)
export const exportBidPdf = (id) =>
  platform
    .get(`/bid/jobs/${id}/export.pdf`, { responseType: 'blob' })
    .then((r) => r.data)
export const exportBidDocx = (id) =>
  platform
    .get(`/bid/jobs/${id}/export.docx`, { responseType: 'blob' })
    .then((r) => r.data)
export const exportBidPptx = (id) =>
  platform
    .get(`/bid/jobs/${id}/export.pptx`, { responseType: 'blob' })
    .then((r) => r.data)

export const exportArtifactPdf = (payload) =>
  platform.post('/artifact/export.pdf', payload, { responseType: 'blob' }).then((r) => r.data)
export const exportArtifactXlsx = (payload) =>
  platform.post('/artifact/export.xlsx', payload, { responseType: 'blob' }).then((r) => r.data)

export const forumConfig = () => platform.get('/forum/config').then((r) => r.data)
export const forumSso = () => platform.post('/forum/sso').then((r) => r.data)
export const listForumThreads = (params) => platform.get('/forum/threads', { params }).then((r) => r.data)
export const createForumThread = (payload) => platform.post('/forum/threads', payload).then((r) => r.data)
export const getForumThread = (id, params) =>
  platform.get(`/forum/threads/${id}`, { params }).then((r) => r.data)
export const createForumPost = (id, payload) =>
  platform.post(`/forum/threads/${id}/posts`, payload).then((r) => r.data)
export const deleteForumThread = (id) => platform.delete(`/forum/threads/${id}`).then((r) => r.data)
export const deleteForumPost = (id) => platform.delete(`/forum/posts/${id}`).then((r) => r.data)
export const reviewForumThread = (id, status) =>
  platform.post(`/forum/threads/${id}/review`, { status }).then((r) => r.data)
export const reviewForumPost = (id, status) =>
  platform.post(`/forum/posts/${id}/review`, { status }).then((r) => r.data)
export const adminForumPending = () => platform.get('/forum/admin/pending').then((r) => r.data)
export const relatedForumThreads = (params) => platform.get('/forum/related', { params }).then((r) => r.data)
export const forumLinkOptions = (params) => platform.get('/forum/link-options', { params }).then((r) => r.data)

export const listArticles = (params) => platform.get('/content/articles', { params }).then((r) => r.data)
export const getArticle = (slug) =>
  platform.get(`/content/articles/${encodeURIComponent(slug)}`).then((r) => r.data)
export const relatedArticles = (params) => platform.get('/content/related', { params }).then((r) => r.data)
export const adminListArticles = (params) =>
  platform.get('/content/admin/articles', { params }).then((r) => r.data)
export const adminGetArticle = (id) => platform.get(`/content/admin/articles/${id}`).then((r) => r.data)
export const adminCreateArticle = (payload) =>
  platform.post('/content/admin/articles', payload).then((r) => r.data)
export const adminUpdateArticle = (id, payload) =>
  platform.put(`/content/admin/articles/${id}`, payload).then((r) => r.data)
export const adminDeleteArticle = (id) =>
  platform.delete(`/content/admin/articles/${id}`).then((r) => r.data)
export const adminImportPreview = (payload) =>
  platform.post('/content/admin/import/preview', payload).then((r) => r.data)
export const adminImportArticle = (payload) =>
  platform.post('/content/admin/import', payload).then((r) => r.data)
export const adminImportBatch = (payload) =>
  platform.post('/content/admin/import/batch', payload).then((r) => r.data)

export default platform
